import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import _ from 'lodash'

import auth from './modules/auth'
/*** rgv imports ***/
import imports from './modules/imports'
import tags from './modules/tags'
import bookmarks from './modules/bookmarks'
import users from './modules/users'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export const storeModules = {
	imports,
  tags,
	bookmarks,
  auth,
  users
};

const initState = () => {
  return {
    loading: false,
    defaultView: 'Regular',
    selectedTags: [],
  }
}

const state = initState()

const actions = {
  resetAllState: async ({ commit }) => {
    commit('resetAllState')
  }
}

const mutations = {
  resetAllState (state) {
    Object.assign(state, initState())
    _.forOwn(storeModules, (value, key) => {
      this.dispatch(key+'/resetState', {}, {root:true})
    });
  },
  setLoading (state, value) {
    Vue.set(state, 'loading', value)
  },
  setDefaultView (state, value) {
    Vue.set(state, 'defaultView', value)
  },
  setSelectedTags (state, value) {
    Vue.set(state, 'selectedTags', value)
  },
  setEntitiesNoOrder (state, { normalizedData }) {
    const normalizedEntities = normalizedData.entities
    for (let type in normalizedEntities) {
      Vue.set(state[type], 'entities', normalizedEntities[type])
    }

    // redirect if new user added bookmarks during this session
    if (state.auth.user.isNew && normalizedData?.entities?.bookmarks)
      if (Object.keys(normalizedData.entities.bookmarks).length > 0)
        Vue.set(state.auth.user, 'isNew', false)
  },
  updateEntities (state, { normalizedData, appendResults }) {
    appendResults = appendResults || false
    // Loop over all kinds of entities we received
    const normalizedEntities = normalizedData.entities
    for (let type in normalizedEntities) {
      // for (let entity in normalizedEntities[type]) {
      //   console.log(`entity: ${entity}`)
      //   const oldObj = state[type][entity] || {}
      //   // Merge the new data in the old object
      //   const newObj = Object.assign(oldObj, normalizedEntities[type][entity])
      //   // Make sure new entities are also reactive
      //   Vue.set(state[type].entities, entity, newObj)
      // }

      let newEntities = normalizedEntities[type]
      if (type != 'tags' || appendResults) {
        newEntities = Object.assign({}, state[type].entities, newEntities)
      }
      Vue.set(state[type], 'entities', newEntities)
    }


    // Loop over all kinds of entities order arrays we received
    const results = normalizedData.result
    for (let type in results) {
      if (type !== "tags") {
        if (Array.isArray(results[type].collection)) {
          if (appendResults) {
            results[type].collection = state[type].entitiesOrder.concat(results[type].collection)
          }

          // for paginated results
          Vue.set(state[type], 'entitiesOrder', results[type].collection)

          if (results[type].metadata) {
            const metadata = results[type].metadata
            // for (let key in metadata) {
            //   Vue.set(state[type].metadata, key, metadata[key])
            // }
            Vue.set(state[type].metadata, 'currentPage', metadata['currentPage'])
            Vue.set(state[type].metadata, 'totalPages', metadata['totalPages'])
            Vue.set(state[type].metadata, 'totalCount', metadata['totalCount'])
            Vue.set(state[type].metadata, 'limitValue', metadata['limitValue'])
          }
        } else if (Array.isArray(results[type])) {
          // for non paginated results
          Vue.set(state[type], 'entitiesOrder', results[type])
        } else if (state[type] && state[type].entitiesOrder) {
          let entitiesOrder = state[type].entitiesOrder
          entitiesOrder.unshift(results[type].id)
          Vue.set(state[type], 'entitiesOrder', entitiesOrder)
        }
      }
    }

    // redirect if new user added bookmarks during this session
    if (state.auth.user.isNew && normalizedData?.entities?.bookmarks)
      if (Object.keys(normalizedData.entities.bookmarks).length > 0)
        Vue.set(state.auth.user, 'isNew', false)
  }
}

export const store = new Vuex.Store({
  state,
  modules: {
    ...storeModules
  },
  actions,
  mutations,
  plugins: [createPersistedState({
    key: 'qlipmarkAuth',
    paths: ['auth.user', 'defaultView']
  })],
  strict: debug
})
